import { I18n } from '@calendly/i18n';
import { Badge } from '@calendly/ui/components/badge';
import classNames from 'classnames';
import { forwardRef } from 'react';
const titleLayoutCss = "t1erg7ya";
const TitleLayout = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(titleLayoutCss, props.className)} />;
});
export const generateTabs = ({
  pathname,
  tabs
}) => {
  const selectedTab = tabs.slice().sort((a, b) => b.route.length - a.route.length).find(tab => tab.route === pathname || pathname.startsWith(`${tab.route}/`));
  return tabs.map(tab => ({
    ...tab,
    key: tab.route,
    selected: tab === selectedTab
  }));
};
export const tabTitleWithBadge = (translatedString, badgeType, hideBadge) => {
  const badgeLabels = {
    beta: I18n.t('publisher.components.badge.beta'),
    new: I18n.t('publisher.action.new')
  };
  return <TitleLayout>
      {translatedString}
      {!hideBadge && <Badge type="new">{badgeLabels[badgeType]}</Badge>}
    </TitleLayout>;
};
export const isSidebarItemEnabled = (sidebarItems, key) => sidebarItems.some(sidebarItem => {
  if (sidebarItem.key === key) return sidebarItem.enabled;
  if (sidebarItem.items?.length) return isSidebarItemEnabled(sidebarItem.items, key);
  return false;
});

require("./helpers.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./helpers.js");